import {
	GET_SAMPLEITEMS_BY_ID,
	CREATE_SAMPLE,
	GET_SAMPLE_ITEMS,
	EDIT_SAMPLE_ITEM,
	DELETE_SAMPLE_ITEM,
	CLEAR_SAMPLE_ATTRIBUTES,
	ADD_SAMPLE_ATTRIBUTES_STATUS,
	GET_SAMPLE_ITEM_TAGS,
	GET_SAMPLE_ITEM_TAG_GROUPS,
	DELETE_ATTRIBUTE_FROM_SAMPLE_ITEM,
	RELATE_TAG_SAMPLE_ITEM,
	UNRELATE_TAG_SAMPLE_ITEM,
	UPDATE_SAMPLE_ATTRIBUTES_STATUS,
	CREATE_TAG,
	DELETE_SAMPLE_TAG,
	EDIT_SAMPLE_TAG,
	DELETE_SAMPLE_TAG_GROUP
} from '../actiontypes';
import {
	createApiReadAction,
	createApiCreateAction,
	createApiUpdateAction,
	createApiDeleteAction,
	API_RESOURCES,
	HTTP_REQUEST_METHODS
} from '../../util/api';

export const getSampleItemsById = (engagementId, sampleListId, sampleItemId, queryString) => {
	return createApiReadAction(
		GET_SAMPLEITEMS_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId
		},
		queryString,
		{
			resolve: true
		}
	);
};
export function createSample(engagementId, sampleListId, payload) {
	return createApiCreateAction(
		CREATE_SAMPLE,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: undefined
		},
		payload
	);
}

export const getSampleItems = (engagementId, sampleListId, queryString) => {
	return createApiReadAction(
		GET_SAMPLE_ITEMS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: undefined
		},
		queryString
	);
};

export const updateSampleItem = (engagementId, sampleListId, sampleItemId, payload) => {
	return createApiUpdateAction(
		EDIT_SAMPLE_ITEM,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId
		},
		payload
	);
};

export const deleteSampleItem = (engagementId, sampleListId, sampleItemId, queryString) => {
	return createApiDeleteAction(
		DELETE_SAMPLE_ITEM,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId
		},
		{sampleItemId},
		true,
		undefined,
		queryString
	);
};

export const clearSampleAttributes = () => {
	return {
		type: CLEAR_SAMPLE_ATTRIBUTES
	};
};

export const addSampleAttributeStatus = (engagementId, sampleListId, sampleItemId, payload) => {
	return createApiCreateAction(
		ADD_SAMPLE_ATTRIBUTES_STATUS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: null
		},
		payload
	);
};

export const updateSampleAttributeStatus = (engagementId, sampleListId, sampleItemId, attributeId, payload) => {
	return createApiUpdateAction(
		UPDATE_SAMPLE_ATTRIBUTES_STATUS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: attributeId
		},
		payload
	);
};

export const getSampleItemTags = (engagementId, queryString, resolve = false) => {
	return createApiReadAction(
		GET_SAMPLE_ITEM_TAGS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGS]: undefined
		},
		queryString,
		{resolve: resolve}
	);
};

export const updateSampleItemTag = (engagementId, tagId, payload) => {
	return createApiUpdateAction(
		EDIT_SAMPLE_TAG,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGS]: tagId
		},
		payload,
		HTTP_REQUEST_METHODS.PUT,
		{sampleItemId: payload?.sampleItemId}
	);
};

export const getSampleItemTagGroups = (engagementId, resolve = false, queryParams) => {
	return createApiReadAction(
		GET_SAMPLE_ITEM_TAG_GROUPS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGGROUPS]: undefined
		},
		queryParams,
		{resolve: resolve}
	);
};

export const removeAttributeFromSampleItem = ({
	engagementId,
	sampleListId,
	sampleItemId,
	attributeId,
	hostDocumentId
}) => {
	return createApiDeleteAction(
		DELETE_ATTRIBUTE_FROM_SAMPLE_ITEM,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: attributeId
		},
		{sampleItemId: sampleItemId, attributeId: attributeId},
		true,
		undefined,
		{hostDocumentId: hostDocumentId}
	);
};

export const relatedSampleItemTags = (engagementId, tagDetails, payload, resolve = false) => {
	return createApiCreateAction(
		RELATE_TAG_SAMPLE_ITEM,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGS]: tagDetails?.engagementTagId,
			[API_RESOURCES.ENTITIES]: undefined
		},
		payload,
		{
			engagementId: engagementId,
			tagDetails: tagDetails,
			sampleItemId: payload?.entitiesUIds[0],
			payload: payload,
			resolve: resolve
		}
	);
};

export const unRelatedSampleItemTags = (engagementId, tagId, payload, resolve = false) => {
	return createApiDeleteAction(
		UNRELATE_TAG_SAMPLE_ITEM,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGS]: tagId,
			[API_RESOURCES.ENTITIES]: undefined
		},
		{tagId: tagId, sampleItemId: payload?.entitiesUIds[0], resolve: resolve},
		true,
		undefined,
		undefined,
		payload
	);
};

export const createTag = (engagementId, bodyData, resolve = true) => {
	const {tagGroupName, ...payload} = bodyData;
	return createApiCreateAction(
		CREATE_TAG,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGS]: undefined
		},
		payload,
		{resolve: resolve, tagData: bodyData}
	);
};

export const deleteSampleTag = (engagementId, tagId, sampleItemId, resolve = true) => {
	return createApiDeleteAction(
		DELETE_SAMPLE_TAG,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGS]: tagId
		},
		{tagId: Number(tagId), sampleItemId: sampleItemId},
		resolve
	);
};

export const deleteSampleTagGroup = (engagementId, tagGroupId, sampleItemId, resolve = true) => {
	return createApiDeleteAction(
		DELETE_SAMPLE_TAG_GROUP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGGROUPS]: tagGroupId
		},
		{tagGroupId: Number(tagGroupId), sampleItemId: sampleItemId},
		resolve
	);
};
